import React, { PureComponent } from 'react'
import {connect} from "react-redux";

import Header from "../../components/Headers/Header";
import {Container, Row, UncontrolledCollapse, CardBody, Card, CardHeader, NavLink } from 'reactstrap';
import {Translate, withLocalize} from "react-localize-redux";
import './faq.css'


import italianFaqTranslations from "../../translations/faq/it.faq.json";
import englishFaqTranslations from "../../translations/faq/en.faq.json";
import Col from "react-bootstrap/Col";
import * as actions from "../../store/actions/actions";

class Campaign extends PureComponent {

    constructor(props) {
        super(props);

        this.props.addTranslationForLanguage(italianFaqTranslations, "it");
        this.props.addTranslationForLanguage(englishFaqTranslations, "en");
    }
    downloadTemplate=()=>{
        this.props.downloadTemplate();
    }
    render() {

        return (
            <>
                <Header />
                <Container className="mt--5" fluid>
                    <Row>
                        <div className="col">
                            <Card className="shadow">
                                <CardHeader className="border-0">
                                    <Row>
                                        <div className="col">
                                            <h3 className="mb-0">
                                                <Translate id="faq.title"/>
                                            </h3>
                                        </div>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    <div className="pl-lg-4">
                                        {/*<ul>*/}
                                        {/*    <li>*/}
                                        <Row>
                                            <Col lg="12">
                                                <NavLink className='faq' href="#" outline size="lg" block color="link" id="togglerLogin"  >
                                                    <Translate id="faq.login.section.title"/>
                                                </NavLink>
                                                <UncontrolledCollapse toggler="#togglerLogin">
                                                    <Card>
                                                        <CardBody>
                                                        {/*<ul>*/}
                                                        {/*    <li>*/}
                                                            <NavLink className='faq' href="#" outline size="lg" block color="link" id="loginQ1"  >
                                                                <Translate id="faq.login.q1"/>
                                                            </NavLink>
                                                            <UncontrolledCollapse toggler="#loginQ1">
                                                                <Card>
                                                                    <CardBody>
                                                                        <Translate id="faq.login.a1"/>
                                                                    </CardBody>
                                                                </Card>
                                                            </UncontrolledCollapse>
                                                            {/*</li><li>*/}
                                                            <NavLink className='faq' href="#" outline size="lg" block color="link" id="loginQ2"  >
                                                                <Translate id="faq.login.q2"/>
                                                            </NavLink>
                                                            <UncontrolledCollapse toggler="#loginQ2">
                                                                <Card>
                                                                    <CardBody>
                                                                        <Translate id="faq.login.a2"/>
                                                                    </CardBody>
                                                                </Card>
                                                            </UncontrolledCollapse>
                                                        {/*</li></ul>*/}

                                                        </CardBody>
                                                    </Card>
                                                </UncontrolledCollapse>
                                            </Col>
                                        </Row>
                                            {/*</li>*/}
                                            {/*<li>*/}
                                        <Row>
                                            <Col lg="12">
                                                <NavLink className='faq' href="#" outline size="lg" block color="link" id="togglerUsers" >
                                                    <Translate id="faq.users.section.title"/>
                                                </NavLink>
                                                <UncontrolledCollapse toggler="#togglerUsers">
                                                    <Card>
                                                        <CardBody>

                                                            <NavLink className='faq' href="#" outline size="lg" block color="link" id="userQ1"  >
                                                                <Translate id="faq.users.q1"/>
                                                            </NavLink>
                                                            <UncontrolledCollapse toggler="#userQ1">
                                                                <Card>
                                                                    <CardBody>
                                                                        <Translate id="faq.users.a1"/>
                                                                    </CardBody>
                                                                </Card>
                                                            </UncontrolledCollapse>

                                                            <NavLink className='faq' href="#" outline size="lg" block color="link" id="userQ2"  >
                                                                <Translate id="faq.users.q2"/>
                                                            </NavLink>
                                                            <UncontrolledCollapse toggler="#userQ2">
                                                                <Card>
                                                                    <CardBody>
                                                                        <Translate id="faq.users.a2"/>
                                                                    </CardBody>
                                                                </Card>
                                                            </UncontrolledCollapse>

                                                            <NavLink className='faq' href="#" outline size="lg" block color="link" id="userQ5"  >
                                                                <Translate id="faq.users.q5"/>
                                                            </NavLink>
                                                            <UncontrolledCollapse toggler="#userQ5">
                                                                <Card>
                                                                    <CardBody>
                                                                        <Translate id="faq.users.a5"/>
                                                                    </CardBody>
                                                                </Card>
                                                            </UncontrolledCollapse>

                                                            <NavLink className='faq' href="#" outline size="lg" block color="link" id="userQ3"  >
                                                                <Translate id="faq.users.q3"/>
                                                            </NavLink>
                                                            <UncontrolledCollapse toggler="#userQ3">
                                                                <Card>
                                                                    <CardBody>
                                                                        <Translate id="faq.users.a3"/>
                                                                    </CardBody>
                                                                </Card>
                                                            </UncontrolledCollapse>

                                                            <NavLink className='faq' href="#" outline size="lg" block color="link" id="userQ4"  >
                                                                <Translate id="faq.users.q4"/>
                                                            </NavLink>
                                                            <UncontrolledCollapse toggler="#userQ4">
                                                                <Card>
                                                                    <CardBody>
                                                                        <Translate id="faq.users.a4"/>
                                                                    </CardBody>
                                                                </Card>
                                                            </UncontrolledCollapse>

                                                        </CardBody>
                                                    </Card>
                                                </UncontrolledCollapse>
                                            </Col>
                                        </Row>
                                            {/*</li>*/}
                                            {/*<li>*/}
                                        <Row>
                                            <Col lg="12">
                                                <NavLink className='faq' className="primary" href="#" outline size="lg" block color="link" id="togglerFile"  >
                                                    <Translate id="faq.file.section.title"/>
                                                </NavLink>
                                                <UncontrolledCollapse toggler="#togglerFile">
                                                    <Card>
                                                        <CardBody>

                                                            <NavLink className='faq' href="#" outline size="lg" block color="link" id="fileQ1"  >
                                                                <Translate id="faq.file.q1"/>
                                                            </NavLink>
                                                            <UncontrolledCollapse toggler="#fileQ1">
                                                                <Card>
                                                                    <CardBody>
                                                                        <Translate id="faq.file.a1"/>
                                                                        <a
                                                                            className="text-light"
                                                                            href="#"
                                                                            onClick={e => this.downloadTemplate()}
                                                                    ><Translate id="faq.file.a1-2"/></a>
                                                                    </CardBody>
                                                                </Card>
                                                            </UncontrolledCollapse>

                                                            <NavLink className='faq' href="#" outline size="lg" block color="link" id="fileQ2"  >
                                                                <Translate id="faq.file.q2"/>
                                                            </NavLink>
                                                            <UncontrolledCollapse toggler="#fileQ2">
                                                                <Card>
                                                                    <CardBody>
                                                                        <Translate id="faq.file.a2"/>
                                                                    </CardBody>
                                                                </Card>
                                                            </UncontrolledCollapse>

                                                            <NavLink className='faq' href="#" outline size="lg" block color="link" id="fileQ3"  >
                                                                <Translate id="faq.file.q3"/>
                                                            </NavLink>
                                                            <UncontrolledCollapse toggler="#fileQ3">
                                                                <Card>
                                                                    <CardBody>
                                                                        <Translate id="faq.file.a3"/>
                                                                    </CardBody>
                                                                </Card>
                                                            </UncontrolledCollapse>

                                                            <NavLink className='faq' href="#" outline size="lg" block color="link" id="fileQ4"  >
                                                                <Translate id="faq.file.q4"/>
                                                            </NavLink>
                                                            <UncontrolledCollapse toggler="#fileQ4">
                                                                <Card>
                                                                    <CardBody>
                                                                        <Translate id="faq.file.a4"/>
                                                                    </CardBody>
                                                                </Card>
                                                            </UncontrolledCollapse>

                                                            <NavLink className='faq' href="#" outline size="lg" block color="link" id="fileQ5"  >
                                                                <Translate id="faq.file.q5"/>
                                                            </NavLink>
                                                            <UncontrolledCollapse toggler="#fileQ5">
                                                                <Card>
                                                                    <CardBody>
                                                                        <Translate id="faq.file.a5"/>
                                                                    </CardBody>
                                                                </Card>
                                                            </UncontrolledCollapse>

                                                            <NavLink className='faq' href="#" outline size="lg" block color="link" id="fileQ6"  >
                                                                <Translate id="faq.file.q6"/>
                                                            </NavLink>
                                                            <UncontrolledCollapse toggler="#fileQ6">
                                                                <Card>
                                                                    <CardBody>
                                                                        <Translate id="faq.file.a6"/>
                                                                    </CardBody>
                                                                </Card>
                                                            </UncontrolledCollapse>

                                                        </CardBody>
                                                    </Card>
                                                </UncontrolledCollapse>
                                            </Col>
                                        </Row>
                                            {/*</li><li>*/}
                                        <Row>
                                            <Col lg="12">
                                                <NavLink className='faq' href="#" outline size="lg" block color="link" id="togglerBank"  >
                                                    <Translate id="faq.bank.section.title"/>
                                                </NavLink>
                                                <UncontrolledCollapse toggler="#togglerBank">
                                                    <Card>
                                                        <CardBody>

                                                            <NavLink className='faq' href="#" outline size="lg" block color="link" id="bankQ1"  >
                                                                <Translate id="faq.bank.q1"/>
                                                            </NavLink>
                                                            <UncontrolledCollapse toggler="#bankQ1">
                                                                <Card>
                                                                    <CardBody>
                                                                        <Translate id="faq.bank.a1"/>
                                                                    </CardBody>
                                                                </Card>
                                                            </UncontrolledCollapse>

                                                        </CardBody>
                                                    </Card>
                                                </UncontrolledCollapse>
                                            </Col>
                                        </Row>
                                        {/*</li><li>*/}
                                        <Row>
                                            <Col lg="12">
                                                <NavLink className='faq' href="#" outline size="lg" block color="link" id="togglerCorporate"  >
                                                    <Translate id="faq.corporate.section.title"/>
                                                </NavLink>
                                                <UncontrolledCollapse toggler="#togglerCorporate">
                                                    <Card>
                                                        <CardBody>

                                                            <NavLink className='faq' href="#" outline size="lg" block color="link" id="corporateQ1"  >
                                                                <Translate id="faq.corporate.q1"/>
                                                            </NavLink>
                                                            <UncontrolledCollapse toggler="#corporateQ1">
                                                                <Card>
                                                                    <CardBody>
                                                                        <Translate id="faq.corporate.a1"/>
                                                                    </CardBody>
                                                                </Card>
                                                            </UncontrolledCollapse>

                                                            <NavLink className='faq' href="#" outline size="lg" block color="link" id="corporateQ2"  >
                                                                <Translate id="faq.corporate.q2"/>
                                                            </NavLink>
                                                            <UncontrolledCollapse toggler="#corporateQ2">
                                                                <Card>
                                                                    <CardBody>
                                                                        <Translate id="faq.corporate.a2"/>
                                                                    </CardBody>
                                                                </Card>
                                                            </UncontrolledCollapse>

                                                            <NavLink className='faq' href="#" outline size="lg" block color="link" id="corporateQ3"  >
                                                                <Translate id="faq.corporate.q3"/>
                                                            </NavLink>
                                                            <UncontrolledCollapse toggler="#corporateQ3">
                                                                <Card>
                                                                    <CardBody>
                                                                        <Translate id="faq.corporate.a3"/>
                                                                    </CardBody>
                                                                </Card>
                                                            </UncontrolledCollapse>

                                                        </CardBody>
                                                    </Card>
                                                </UncontrolledCollapse>
                                            </Col>
                                        </Row>
                                        {/*</li><li>*/}
                                        <Row>
                                            <Col lg="12">
                                                <NavLink className='faq' href="#" outline size="lg" block color="link" id="togglerCampaign"  >
                                                    <Translate id="faq.campaign.section.title"/>
                                                </NavLink>
                                                <UncontrolledCollapse toggler="#togglerCampaign">
                                                    <Card>
                                                        <CardBody>

                                                            <NavLink className='faq' href="#" outline size="lg" block color="link" id="campaignQ1"  >
                                                                <Translate id="faq.campaign.q1"/>
                                                            </NavLink>
                                                            <UncontrolledCollapse toggler="#campaignQ1">
                                                                <Card>
                                                                    <CardBody>
                                                                        <Translate id="faq.campaign.a1"/>
                                                                    </CardBody>
                                                                </Card>
                                                            </UncontrolledCollapse>

                                                            <NavLink className='faq' href="#" outline size="lg" block color="link" id="campaignQ2"  >
                                                                <Translate id="faq.campaign.q2"/>
                                                            </NavLink>
                                                            <UncontrolledCollapse toggler="#campaignQ2">
                                                                <Card>
                                                                    <CardBody>
                                                                        <Translate id="faq.campaign.a2"/>
                                                                    </CardBody>
                                                                </Card>
                                                            </UncontrolledCollapse>

                                                        </CardBody>
                                                    </Card>
                                                </UncontrolledCollapse>
                                            </Col>
                                        </Row>
                                        {/*</li><li>*/}
                                        <Row>
                                            <Col lg="12">
                                                <NavLink className='faq' href="#" outline size="lg" block color="link" id="togglerReport"  >
                                                    <Translate id="faq.report.section.title"/>
                                                </NavLink>
                                                <UncontrolledCollapse toggler="#togglerReport">
                                                    <Card>
                                                        <CardBody>

                                                            <NavLink className='faq' href="#" outline size="lg" block color="link" id="reportQ1"  >
                                                                <Translate id="faq.report.q1"/>
                                                            </NavLink>
                                                            <UncontrolledCollapse toggler="#reportQ1">
                                                                <Card>
                                                                    <CardBody>
                                                                        <Translate id="faq.report.a1"/>
                                                                    </CardBody>
                                                                </Card>
                                                            </UncontrolledCollapse>

                                                            <NavLink className='faq' href="#" outline size="lg" block color="link" id="reportQ2"  >
                                                                <Translate id="faq.report.q2"/>
                                                            </NavLink>
                                                            <UncontrolledCollapse toggler="#reportQ2">
                                                                <Card>
                                                                    <CardBody>
                                                                        <Translate id="faq.report.a2"/>
                                                                    </CardBody>
                                                                </Card>
                                                            </UncontrolledCollapse>

                                                            <NavLink className='faq' href="#" outline size="lg" block color="link" id="reportQ3"  >
                                                                <Translate id="faq.report.q3"/>
                                                            </NavLink>
                                                            <UncontrolledCollapse toggler="#reportQ3">
                                                                <Card>
                                                                    <CardBody>
                                                                        <Translate id="faq.report.a3"/>
                                                                    </CardBody>
                                                                </Card>
                                                            </UncontrolledCollapse>

                                                        </CardBody>
                                                    </Card>
                                                </UncontrolledCollapse>
                                            </Col>
                                        </Row>
                                        {/*</li></ul>*/}




                                    </div>
                                </CardBody>
                            </Card>

                        </div>
                    </Row>
                </Container>
            </>
        );
    }
}

const mapStateToProps = state => {
    return {

    }
}

const mapDispatchToProps = dispatch => {
    return {
        downloadTemplate:() => dispatch({type:actions.DOWNLOAD_CORPORATE_TEMPLATE_REQUEST})
    }
}

export default withLocalize(connect(mapStateToProps, mapDispatchToProps)(Campaign));